module.exports = __webpack_public_path__ + "static/media/ethereum-logo.8e821114.png";